<template>
  <div>
    <div class="common-header">
      <es-breadcrumb>
        <es-breadcrumb-item :to="{ path: '/MyOrder' }">{{ $t('我的订单') }}</es-breadcrumb-item>
        <es-breadcrumb-item>{{ $t('开票') }}</es-breadcrumb-item>
      </es-breadcrumb>
      <span class="common-header-tip">{{ $t('提示：可能有部分金额已开过发票，此处不计入可开票金额内。') }}</span>
    </div>
    <divided />
    <div class="result common-body">
      <div class="result-title">
        <img src="../../assets/common/success.png" class="result-title-img" />
        <span class="result-title-tip">{{ $t('恭喜，您的开票申请已提交成功！') }}</span>
        <div style="color: #1a1a1a; margin-bottom: 24px; font-weight: 400; margin-top: 14px">
          <span
            >{{ $t('开票订单：')
            }}{{
              $t('{slot1}笔', {
                slot1: totalNums,
              })
            }}，</span
          >
          <span
            >{{ $t('开票总金额：')
            }}{{
              $t('{slot1}元', {
                slot1: totalPrice.toFixed(2),
              })
            }}</span
          >
        </div>
        <div style="margin-bottom: 60px">
          <div class="result-title-btn" @click="$router.push('/MyOrder')">{{ $t('查看全部订单') }}</div>
        </div>
        <p style="margin-bottom: 20px" v-if="orderList.length > 1">
          {{ $t('合并开票订单：')
          }}{{
            $t('{slot1}，按归属公司分别合并开票', {
              slot1: companyOrderTipss,
            })
          }}
        </p>
        <p style="margin-bottom: 50px">
          {{
            $t('根据税务局相关规定，软件类产品需单独开具发票，因此您可能会收到同一服务主体出具的多张发票，所有发票均真实有效，可正常使用。')
          }}
        </p>
      </div>
      <div v-if="$route.query.invoiceForm == 1" style="width: 100%">
        <es-table :data="orderList">
          <template slot="empty"
            ><es-empty
              style="margin: 25px; color: #999; line-height: 40px"
              :description="$t(`暂无更多数据`)"
              image="data:image/png;base64,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"
            ></es-empty>
          </template>
          <es-table-column :label="$t(`发票抬头`)">
            <template slot-scope="scope">
              {{ scope.row.invoiceTitleName || '' }}
            </template>
          </es-table-column>
          <es-table-column :label="$t(`归属公司`)">
            <template slot-scope="scope">
              {{ scope.row.companyName || '' }}
            </template>
          </es-table-column>
          <es-table-column :label="$t(`订单金额(元)`)">
            <template slot-scope="scope">
              {{ scope.row.invoiceAmount.toFixed(2) }}
            </template>
          </es-table-column>
          <es-table-column :label="$t(`状态`)">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center" v-if="scope.row.success">
                <span class="yuan"></span>{{ $t('电子发票已开') }}
              </div>
              <span v-else>{{ $t('开票失败') }}</span>
            </template>
          </es-table-column>
          <es-table-column :label="$t(`操作`)">
            <template slot-scope="scope">
              <es-button type="text" @click="jumpToEle(scope.row.orderId)" v-if="scope.row.success">{{ $t('获取发票') }}</es-button>
            </template>
          </es-table-column>
        </es-table>

        <div class="result-invoice" v-show="showAllTip" style="color: #e61717">
          {{ $t('由于您的开票申请涉及未全额付款订单，因此需要2个工作日的审批后开具！') }}
          <span style="color: #999">{{ $t('（请在订单管理中及时获取开具的电子发票）') }}</span>
        </div>
      </div>
      <div class="result-tip" v-if="$route.query.invoiceForm == 2">
        <span>{{ $t('提示：您申请开具的发票将在7个工作日内寄出，请注意查收！') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import { mapState } from 'vuex'
import divided from '../../components/divided'
import mixin from '../cost/mixin'
export default {
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isOrg: state => state.isOrg,
    }),
    totalPrice() {
      let total = 0
      this.orderList.forEach(item => {
        item.showPrice = item.price - item.invoiceTotal || 0
        if (item.amountPaid < item.price) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.showAllTip = true
        }
        total = this.addCal(total, item.invoiceAmount)
      })

      return total
    },
    totalNums() {
      let total = 0
      this.orderList.forEach(item => {
        total += item.orderIds.length || 0
      })

      return total
    },
    companyOrderTipss() {
      return this.orderList.map(v => $t('{slot1} {slot2} 笔', { slot1: v.companyName, slot2: v.orderIds.length })).join('，')
    },
  },
  mixins: [mixin],
  components: {
    divided,
  },
  data() {
    return {
      price: 0,
      orderId: '',
      showAllTip: false,
      successed: false,
      orderList: [],
      ouid: '',
    }
  },
  created() {},
  mounted() {
    this.ouid = localStorage.getItem('ouid')
    this.queryInvoiceCombine(this.$route.query.combineCode || '')
  },
  methods: {
    jumpToEle(orderId) {
      this.$router.push({
        path: '/ElecInvoice',
        query: {
          orderId,
        },
      })
    },
    // 查询开票结果
    queryInvoiceCombine(combineCode) {
      if (!combineCode) return
      const oid = this.userInfo.orgId ? this.userInfo.orgId : this.ouid
      this.$ajax(this.$url.queryInvoiceCombine(oid), { combineCode })
        .then(res => {
          if (res.code === 20502002) {
            this.$message.error(res.message)
            this.$router.push('/Myorder')
          } else {
            this.successed = res.success
            if (res.success) {
              this.orderList = res.data || []
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
}
</script>
<style lang="less" scoped>
.result {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 62px;
  &-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    &-img {
      width: 60px;
      height: 60px;
      margin-bottom: 23px;
    }
    &-tip {
      color: #1a1a1a;
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 7px;

      font-weight: 500;
    }
    &-reason {
      color: #999999;
      font-size: 12px;
      line-height: 17px;
      margin-bottom: 13px;
    }
    &-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 120px;
      height: 32px;
      line-height: 32px;
      background: #0975e0;
      color: white;
      font-size: 14px;
      cursor: pointer;
      border-radius: 3px;
    }
  }

  &-invoice {
    background: #e9e9e9;
    color: #999999;
    font-size: 12px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 80px;
    border-bottom: 1px dashed #ddd;
    div {
      flex: 1;
      font-size: 12px;
    }
    div:last-child {
      border-bottom: 1px dashed transparent;
      display: flex;
      justify-content: space-between;
    }
  }
  &-tip {
    margin-top: 20px;
    color: #999999;
    font-size: 12px;
    line-height: 17px;
  }
}
.yuan {
  background: #11cb02;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 10px;
}
/deep/ .es-empty__image {
  width: 64px;
}
</style>
